<template>
  <div
    class="whitecard flex-column align-items-center gap16"
    style="padding: 32px 16px"
  >
    <!-- <div
      v-if="askForHelpPage === 'main'"
      class="flex-column align-items-center gap32"
      style="max-width: 295px;"
    > -->
    <div
      class="flex-column align-items-center gap32"
      style="max-width: 295px;"
    >
      <div>
        <IllustrationsHelp />
      </div>
      <div class="flex-column align-items-start padding0 gap24 stretch">
        <div class="flex-column align-items-start padding0 gap16">
          <div class="flex-row justify-content-center stretch">
            <h2 class="h bold flex-row stretch align-items-center">
              {{ $t('bnpl:askForHelp') }}
            </h2>
          </div>
          <p class="p-body gray600">
            {{ $t('bnpl:askForHelpText') }}
          </p>
        </div>
        <div class="flex-column align-items-center padding0 gap16 stretch">
          <a target="_blank" :href="`https://m.me/${countryStore.messengerPageId}`">
            <div class="flex-row align-items-center padding0 gap24">
              <div style="width:80px;height:80px;">
                <!-- <IllustrationsCall /> -->
                <IconsFacebookMessenger />
              </div>
              <div class="flex-column align-items-start justify-content-center padding0 gap4 grow">
                <p class="p-caption bold gray600">
                  {{ $t("bnpl:chat_on_facebook_messenger") }}
                </p>
                <a class="btn btnM stretch" target="_blank" :href="`https://m.me/${countryStore.messengerPageId}`">
                  {{ $t("bnpl:chat_on_facebook_messenger_button") }}
                </a>
              </div>
            </div>
          </a>
          <!-- <p class="p-caption">
            {{ $t('bnpl:or') }}
          </p>
          <button
            class="btn btnL stretch"
            @click="askForCallback"
          >
            {{ $t('bnpl:askForCallback') }}
          </button> -->
        </div>
      </div>
    </div>
    <!-- <div
      v-else-if="askForHelpPage === 'callBackForm'"
      class="flex-column align-items-center padding0 gap32 stretch"
    >
      <h2 class="h bold">
        {{ $t('bnpl:askingForCallback') }}
      </h2>
      <div class="grid-container stretch">
        <div class="inputField">
          <label class="p-caption bold">{{ $t('bnpl:lastName') }}</label>
          <input
            v-model="callBackForm.lastName"
            class="textInput"
          >
        </div>
        <div class="inputField">
          <label class="p-caption bold">{{ $t('bnpl:firstName') }}</label>
          <input
            v-model="callBackForm.firstName"
            class="textInput"
          >
        </div>
        <div class="inputField">
          <label class="p-caption bold">{{ $t('bnpl:phone') }}</label>
          <input
            v-model="callBackForm.phone"
            class="textInput"
          >
        </div>
        <div class="inputField">
          <label class="p-caption bold">{{ $t('bnpl:emailAddress') }}</label>
          <input
            v-model="callBackForm.email"
            class="textInput"
            type="email"
          >
          <p
            v-if="callBackForm.email && !validateEmail(callBackForm.email)"
            class="p-caption bold"
            style="color:var(--systemError)"
          >
            Érvénytelen e-mail cím
          </p>
        </div>
        <div class="inputField">
          <label class="p-caption bold">{{ $t('bnpl:preferredDate') }}</label>
          <InputCalendar
            :default-value="new Date()"
            @input="writeDate($event)"
          />
        </div>
        <div class="inputField">
          <label class="p-caption bold">{{ $t('bnpl:preferredTime') }}</label>
          <div class="flex-row justify-content-center align-items-center">
            <input
              v-model="callBackForm.preferredHour"
              class="textInput timeInput"
              type="number"
              min="0"
              max="23"
            >
            &nbsp;:&nbsp;
            <input
              v-model="callBackForm.preferredMinute"
              class="textInput timeInput"
              type="number"
              min="0"
              max="59"
            >
          </div>
        </div>
      </div>
      <button
        class="btn btnL"
        :disabled="isCallBackFormFilled || !validateEmail(callBackForm.email)"
        @click="sendCallBack"
      >
        {{ $t('bnpl:send') }}
      </button>
    </div> -->
    <!-- <div
      v-else-if="askForHelpPage === 'callBackSuccess'"
      class="flex-column align-items-center padding0 gap32"
    >
      <IllustrationsSuccess />
      <div class="flex-column align-items-start padding0 gap24 stretch">
        <div class="flex-column align-items-center padding0 gap16 stretch">
          <div class="flex-row justify-content-center stretch">
            <h2
              class="h bold"
              style="color:var(--systemSuccess)"
            >
              {{ $t('bnpl:cbr.success') }}
            </h2>
          </div>
          <p class="p-body gray600">
            {{ $t('bnpl:askForCallbackSuccess') }}
          </p>
          <button
            class="btn btnL"
            @click="back"
          >
            {{ $t('bnpl:back') }}
          </button>
        </div>
      </div>
    </div> -->
    <!-- <div
      v-else-if="askForHelpPage === 'callBackFail'"
      class="flex-column align-items-center padding0 gap32"
    >
      <IllustrationsError />
      <div class="flex-column align-items-start padding0 gap24 stretch">
        <div class="flex-column align-items-center padding0 gap16 stretch">
          <div class="flex-row justify-content-center stretch">
            <h2
              class="h bold"
              style="color:var(--systemError)"
            >
              {{ $t('bnpl:cbr.fail') }}
            </h2>
          </div>
          <p class="p-body gray600">
            {{ $t('bnpl:askForCallbackFail') }}
          </p>
          <button
            class="btn btnL"
            @click="back"
          >
            {{ $t('bnpl:back') }}
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import Network from "~/utils/network";
import {maskValue} from "~/utils/util";
import {useProfileStore} from "~/stores/profile";
import { useCountryStore } from "~~/stores/country";

const askForHelpPage = ref('main');

const isCallBackFormFilled = ref(false);

const profileStore = useProfileStore();
const countryStore = useCountryStore();

function checkCallBackFormFilled () {
  callBackForm.phone = maskValue(FIELD_MASK.PHONE, callBackForm.phone);
  callBackForm.preferredHour = callBackForm.preferredHour?.toString().slice(0,2);
  callBackForm.preferredMinute = callBackForm.preferredMinute?.toString().slice(0,2);
  isCallBackFormFilled.value = Object.values(callBackForm).some(e => !e);
}

const callBackForm = reactive({
  firstName: profileStore.profile.firstName,
  lastName: profileStore.profile.lastName,
  email: profileStore.profile.email,
  phone: profileStore.profile.phone?.slice(-9) ?? '+36',
  preferredHour: '14',
  preferredMinute: '00',
  preferredDate: null,
})

watch(callBackForm, checkCallBackFormFilled, {deep: true});

onMounted(() => {checkCallBackFormFilled()});

function askForCallback() {
  askForHelpPage.value = 'callBackForm';
}

async function sendCallBack() {
  try {
    await Network.http("/call-me-back", {
      method: 'POST', body: {
        email: callBackForm.email,
        phone: callBackForm.phone,
        firstName: callBackForm.firstName,
        lastName: callBackForm.lastName,
        preferredDate: callBackForm.preferredDate,
        preferredTime: callBackForm.preferredHour.toString().padStart(2, '0') + ':' + callBackForm.preferredMinute.toString().padStart(2, '0'),
        type: 'CBR_BTN',
        origin: 'BNPL',
      }
    })
    askForHelpPage.value = 'callBackSuccess';
  }
  catch (e) {
    askForHelpPage.value = 'callBackFail';
  }
}

function back() {
  askForHelpPage.value = 'main';
}

function writeDate(value) {
  callBackForm.preferredDate = formatDate(value);
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 24px;
}

@media only screen and (max-width: 792px) {
  .grid-container  {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

.timeInput {
  width: 4em;
  text-align: center;
  /* Firefox */
  -moz-appearance: textfield;
}
</style>